(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shc-cart-page"]) return;
  try {
    
  if (!customElements.get('shc-cart-page')) {
    customElements.define('shc-cart-page', class extends HTMLElement {
      connectedCallback() {
        this.onClick = this.handleClick.bind(this);
        this.onChange = this.handleChange.bind(this);
        this.onInput = (event) => {
          if (!event.target.matches('[data-quantity-input]')) return;
          clearTimeout(this.quantityTimer);
          const input = event.target;
          this.quantityTimer = setTimeout(() => { if (input.isConnected) this.handleChange({ target: input }); }, 450);
        };
        this.onKeydown = (event) => {
          if (event.key === 'Enter' && event.target.matches('[data-quantity-input]')) {
            event.preventDefault();
            this.handleChange(event);
          }
        };
        this.onSubmit = (event) => { if (this.busy) event.preventDefault(); };
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.addEventListener('input', this.onInput);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('submit', this.onSubmit);
        this.observeCheckout();
        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source !== 'shc-cart-page') this.refresh();
          });
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
        this.controller?.abort();
        clearTimeout(this.quantityTimer);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('input', this.onInput);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('submit', this.onSubmit);
      }
      observeCheckout() {
        this.observer?.disconnect();
        const button = this.querySelector('[data-summary-checkout]');
        const sticky = this.querySelector('[data-sticky-checkout]');
        if (!button || !sticky) return;
        this.observer = new IntersectionObserver((entries) => {
          const covered = entries[0].intersectionRatio >= 0.98;
          sticky.classList.toggle('is-covered', covered);
          sticky.inert = covered;
        }, { threshold: [0, 0.98, 1] });
        this.observer.observe(button);
      }
      handleClick(event) {
        const remove = event.target.closest('[data-cart-remove]');
        const stepButton = event.target.closest('[data-quantity-step]');
        if (!remove && !stepButton) return;
        event.preventDefault();
        if (this.busy) return;
        const row = event.target.closest('[data-cart-key]');
        const input = row.querySelector('[data-quantity-input]');
        let quantity = 0;
        if (stepButton) {
          const direction = Number(stepButton.dataset.quantityStep);
          quantity = Number(input.value) + Number(input.step || 1) * direction;
          const minimum = Number(input.dataset.min || 1);
          if (direction < 0 && quantity < minimum) quantity = 0;
          if (direction > 0 && quantity < minimum) quantity = minimum;
        }
        this.change(row, quantity, stepButton?.dataset.quantityStep || 'remove');
      }
      handleChange(event) {
        clearTimeout(this.quantityTimer);
        if (!event.target.matches('[data-quantity-input]') || this.busy) return;
        const input = event.target;
        const quantity = Number(input.value);
        const minimum = Number(input.dataset.min || 1);
        if (input.value === input.defaultValue) return;
        if (!input.value.trim() || !input.checkValidity() || !Number.isInteger(quantity) || (quantity > 0 && quantity < minimum)) {
          this.showError(this.dataset.quantityError, input.closest('[data-cart-key]'));
          input.value = input.defaultValue;
          return;
        }
        this.change(input.closest('[data-cart-key]'), quantity, 'input');
      }
      setBusy(busy) {
        this.busy = busy;
        this.setAttribute('aria-busy', String(busy));
        this.querySelectorAll('button, input').forEach((control) => {
          if (busy) { control.dataset.wasDisabled = String(control.disabled); control.disabled = true; }
          else if (control.dataset.wasDisabled !== undefined) { control.disabled = control.dataset.wasDisabled === 'true'; delete control.dataset.wasDisabled; }
        });
      }
      showError(message, row) {
        const target = row?.querySelector('[data-row-error]') || this.querySelector('[data-cart-error]');
        if (target) { target.textContent = message; target.hidden = false; }
      }
      renderPage(html, focusKey, focusControl) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const content = parsed.querySelector('[data-shc-page-content]');
        if (!content) throw new Error(this.dataset.error);
        const detailsOpen = this.querySelector('.shc-cart-page__help')?.open;
        this.querySelector('[data-shc-page-content]').replaceWith(content);
        if (detailsOpen && this.querySelector('.shc-cart-page__help')) this.querySelector('.shc-cart-page__help').open = true;
        this.observeCheckout();
        if (focusKey) {
          const row = [...this.querySelectorAll('[data-cart-key]')].find((item) => item.dataset.cartKey === focusKey);
          const selector = focusControl === 'input' ? '[data-quantity-input]' : `[data-quantity-step="${focusControl}"]`;
          const focusTarget = row?.querySelector(selector) || this.querySelector('[data-quantity-input]') || this.querySelector('.shc-cart-page__empty a');
          focusTarget?.focus({ preventScroll: true });
        }
      }
      renderDrawer(data) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections['cart-drawer']) {
          const parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
          const fresh = parsed.querySelector('#CartDrawer');
          const target = drawer.querySelector('#CartDrawer');
          if (fresh && target) {
            target.replaceChildren(...fresh.childNodes);
            drawer.classList.toggle('is-empty', data.item_count === 0);
            drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
            drawer.applyPresentation?.();
          }
        }
        if (data.sections['cart-icon-bubble']) {
          const parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          const bubble = document.querySelector('#cart-icon-bubble');
          if (bubble) bubble.innerHTML = parsed.querySelector('.shopify-section')?.innerHTML || '';
        }
      }
      async change(row, quantity, focusControl) {
        if (this.busy || quantity < 0) return;
        const key = row.dataset.cartKey;
        this.querySelectorAll('[data-row-error], [data-cart-error]').forEach((error) => { error.hidden = true; });
        this.setBusy(true);
        this.querySelector('[data-cart-status]').textContent = this.dataset.updating;
        this.controller = new AbortController();
        try {
          const response = await fetch(this.dataset.changeUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, signal: this.controller.signal,
            body: JSON.stringify({ id: key, quantity, sections: [this.dataset.sectionId, 'cart-icon-bubble', 'cart-drawer'], sections_url: this.dataset.cartUrl })
          });
          const data = await response.json();
          if (!response.ok || data.status || data.errors) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
          if (!data.sections?.[this.dataset.sectionId]) { location.reload(); return; }
          this.renderPage(data.sections[this.dataset.sectionId], key, focusControl);
          this.renderDrawer(data);
          this.querySelector('[data-cart-status]').textContent = this.dataset.updated;
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shc-cart-page', cartData: data });
        } catch (error) {
          if (error.name !== 'AbortError') {
            row.querySelector('[data-quantity-input]').value = row.querySelector('[data-quantity-input]').defaultValue;
            this.showError(error.message || this.dataset.error, row.isConnected ? row : null);
            this.querySelector('[data-cart-status]').textContent = '';
          }
        } finally {
          this.setBusy(false);
          if (this.needsRefresh) { this.needsRefresh = false; this.refresh(); }
        }
      }
      async refresh() {
        if (this.busy) { this.needsRefresh = true; return; }
        this.setBusy(true);
        this.controller = new AbortController();
        try {
          const url = new URL(this.dataset.cartUrl, location.origin);
          url.searchParams.set('sections', this.dataset.sectionId);
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error(this.dataset.error);
          const sections = await response.json();
          this.renderPage(sections[this.dataset.sectionId]);
        } catch (error) {
          if (error.name !== 'AbortError') location.reload();
        } finally { this.setBusy(false); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shc-design"]) return;
  try {
    
if (!customElements.get('shc-sticky-buy')) {
  customElements.define('shc-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      if (!this.product) return;
      this.action = this.querySelector('button');
      this.price = this.querySelector('.shc-sticky-buy__price');
      this.variant = this.querySelector('.shc-sticky-buy__variant');
      this.sync = () => {
        const button = this.product.querySelector('product-form button[name="add"]');
        const price = this.product.querySelector('[id^="price-"] .price');
        if (!button) return;
        this.action.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
        this.action.textContent = button.querySelector('span')?.textContent.trim() || this.dataset.label;
        const shownPrice = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price-item--regular');
        if (shownPrice) this.price.textContent = shownPrice.textContent.trim();
        const options = [...this.product.querySelectorAll('variant-selects select, variant-selects input:checked')].map(input => input.value);
        if (options.length) this.variant.textContent = options.join(' / ');
      };
      this.onClick = () => {
        const button = this.product.querySelector('product-form button[name="add"]');
        if (button && !this.action.disabled) {
          button.scrollIntoView({block:'center',behavior:'instant'});
          button.click();
        }
      };
      this.action.addEventListener('click', this.onClick);
      this.sync();
      const button = this.product.querySelector('product-form button[name="add"]');
      if (button) {
        this.intersection = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, {threshold:0});
        this.intersection.observe(button);
      }
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.sync();
      });
      this.observer.observe(this.product, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
      this.product.addEventListener('change', this.sync);
    }
    disconnectedCallback() {
      this.intersection?.disconnect();
      this.observer?.disconnect();
      this.product?.removeEventListener('change',this.sync);
      this.action?.removeEventListener('click',this.onClick);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shc3-club-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shc3-product-faq')) {
    customElements.define('shc3-product-faq', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-shc3-fit-open]');
        if (!button || this.openSizeFinder) return;
        const primaryButton = () => this.closest('main')?.querySelector('shc3-product [data-shc3-fit-open]');
        const controls = primaryButton()?.getAttribute('aria-controls');
        if (controls) button.setAttribute('aria-controls', controls);
        else button.removeAttribute('aria-controls');
        this.openSizeFinder = () => primaryButton()?.click();
        button.addEventListener('click', this.openSizeFinder);
      }
      disconnectedCallback() {
        this.querySelector('[data-shc3-fit-open]')?.removeEventListener('click', this.openSizeFinder);
        this.openSizeFinder = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shc3-collection"] && !Shopify.designMode) return;
  try {
    
const shcPublish = (name, data) => { try { const result = window.Shopify?.analytics?.publish(name, data); result?.catch?.(() => {}); } catch {} };
document.addEventListener('shc:collection-pin', event => shcPublish('shc:collection_pin', { ...event.detail, collection: document.querySelector('[data-collection-handle]')?.dataset.collectionHandle }));
document.addEventListener('click', event => {
 const link = event.target.closest('.shc3-collection-page .c-product a');
 if (!link || link.matches('[data-shc-quick-open]')) return;
 const card = link.closest('.c-product'), section = card.closest('[data-collection-handle]');
 shcPublish('shc:collection_product_clicked', { collection: section.dataset.collectionHandle, product: card.dataset.productHandle, position: [...card.parentElement.children].filter(el => el.matches('.c-product')).indexOf(card) + 1, pinned: card.dataset.shcPinned === 'true' });
});
for (const section of document.querySelectorAll('[data-shc-first-status]')) shcPublish('shc:collection_pin', { status: section.dataset.shcFirstStatus, product: section.querySelector('[data-shc-pinned]')?.dataset.productHandle || '', collection: section.dataset.collectionHandle });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shc3-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  let observer;
  const sync = (cartIcon) => {
    cartIcon.querySelectorAll('.c-cart-count, .cart-count-bubble').forEach((badge) => {
      const countElement = badge.querySelector('[aria-hidden="true"]') || badge;
      const count = Number.parseInt(countElement.textContent.trim(), 10);
      badge.classList.toggle('shc-cart-pulse', Number.isFinite(count) && count > 0);
    });
  };
  const connect = () => {
    if (observer) observer.disconnect();
    const cartIcon = document.querySelector('.c-header #cart-icon-bubble');
    if (!cartIcon) return;
    sync(cartIcon);
    observer = new MutationObserver(() => sync(cartIcon));
    observer.observe(cartIcon, { childList: true, characterData: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
  document.addEventListener('shopify:section:load', connect);
  window.addEventListener('pageshow', connect);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shc3-product"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('shc3-product')){
 customElements.define('shc3-product',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;this.pending=false;this.sizeChosen=new URL(location.href).searchParams.has('variant');
   this.addEventListener('change',e=>{if(e.target.matches('[data-option-value-id]')){if(e.target.closest('fieldset').dataset.optionName==='size')this.sizeChosen=true;this.updateOptions(e.target);}});
   this.addEventListener('submit',e=>{if(e.target.matches('.shc3-product-form')){e.preventDefault();this.addToCart(e.target);}});
   this.addEventListener('click',e=>{
    const color=e.target.closest('[data-shc3-color-value]');
    if(color){const input=this.querySelector('input[data-option-value-id="'+CSS.escape(color.dataset.shc3ColorValue)+'"]');if(input){input.checked=true;this.updateOptions(input);this.querySelector('[data-options]').scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}}
    const thumb=e.target.closest('[data-shc3-image]');
    if(thumb){const img=this.querySelector('.p-main-image');img.src=thumb.dataset.shc3Image;img.removeAttribute('srcset');img.alt=thumb.dataset.alt;this.querySelectorAll('.p-thumb').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));}
    if(e.target.closest('[data-shc3-zoom]')){const dialog=this.querySelector('.shc3-zoom'),img=this.querySelector('.p-main-image');if(img){dialog.querySelector('img').src=img.currentSrc||img.src;dialog.querySelector('img').alt=img.alt;dialog.showModal();}}
    if(e.target.closest('.shc3-close-zoom'))this.querySelector('.shc3-zoom').close();
   });
   this.querySelector('.shc3-zoom')?.addEventListener('click',e=>{if(e.target===e.currentTarget)e.currentTarget.close();});
   if(!this.sizeChosen)this.clearSize();
  }
  clearSize(){const field=this.querySelector('[data-option-name="size"]');if(field){field.querySelectorAll('input').forEach(i=>i.checked=false);field.querySelector('legend strong').textContent='—';}}
  async updateOptions(input){
   this.controller?.abort();this.controller=new AbortController();const controller=this.controller;this.pending=true;
   const button=this.querySelector('[name=add]'),variant=this.querySelector('[name=id]');button.disabled=true;variant.disabled=true;this.querySelector('.p-error').textContent='';
   const optionIds=Array.from(this.querySelectorAll('[data-option-value-id]:checked')).map(i=>i.dataset.optionValueId);
   const url=new URL(input.dataset.productUrl||this.dataset.productUrl,location.origin);url.search=new URL(location.href).search;
   url.searchParams.delete('variant');url.searchParams.set('section_id',this.dataset.sectionId);url.searchParams.set('option_values',optionIds.join(','));
   try{
    const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw new Error('variant');
    const html=new DOMParser().parseFromString(await response.text(),'text/html'),fresh=html.querySelector('shc3-product');if(!fresh)throw new Error('variant');
    const focused=input.dataset.optionValueId;
    for(const sel of ['[data-options]','[data-price]','[data-media]','[data-cart-control]']){const old=this.querySelector(sel),replacement=fresh.querySelector(sel);if(old&&replacement)old.replaceWith(replacement);}
    this.dataset.currentVariant=fresh.dataset.currentVariant;
    if(!this.sizeChosen)this.clearSize();
    const checkedColor=this.querySelector('[data-option-name="color"] input:checked,[data-option-name="colour"] input:checked');
    this.querySelectorAll('[data-shc3-color-value]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.shc3ColorValue===checkedColor?.dataset.optionValueId)));
    const publicUrl=new URL(this.dataset.productUrl,location.origin);publicUrl.search=new URL(location.href).search;publicUrl.searchParams.delete('option_values');
    if(fresh.dataset.currentVariant)publicUrl.searchParams.set('variant',fresh.dataset.currentVariant);else publicUrl.searchParams.delete('variant');
    history.replaceState({},'',publicUrl);
    this.querySelector('[data-option-value-id="'+CSS.escape(focused)+'"]')?.focus({preventScroll:true});
   }catch(error){if(error.name!=='AbortError'){this.querySelector('.p-error').textContent=this.dataset.updateError;this.querySelectorAll('[data-option-value-id]:checked').forEach(i=>i.checked=false);}}
   finally{if(this.controller===controller)this.pending=false;}
  }
  async addToCart(form){
   if(this.pending)return;
   const sizeField=this.querySelector('[data-option-name="size"]');
   if(sizeField&&!sizeField.querySelector('input:checked')){this.querySelector('.p-error').textContent=this.dataset.chooseSize;sizeField.querySelector('input')?.focus();return;}
   const button=form.querySelector('[name=add]'),id=form.querySelector('[name=id]');if(!id.value||id.disabled)return;
   this.pending=true;button.disabled=true;const label=button.textContent;button.textContent=this.dataset.adding;this.querySelector('.p-error').textContent='';
   try{
    const root=window.Shopify?.routes?.root||'/';
    const drawer=document.querySelector('cart-drawer');
    const payload={items:[{id:Number(id.value),quantity:1}]};
    if(drawer?.getSectionsToRender){payload.sections=drawer.getSectionsToRender().map(section=>section.id);payload.sections_url=window.location.pathname;drawer.setActiveElement(button);}
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
    const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||this.dataset.cartError);
    button.textContent=this.dataset.added;this.querySelector('.shc3-view-cart').hidden=false;
    if(drawer){
     try{
      if(!result.sections?.['cart-drawer']){
       const url=new URL(root,location.origin);url.searchParams.set('sections',drawer.getSectionsToRender().map(section=>section.id).join(','));
       const refreshed=await fetch(url,{headers:{Accept:'application/json'}});if(!refreshed.ok)throw new Error('cart-section');result.sections=await refreshed.json();
      }
      if(!result.sections?.['cart-drawer'])throw new Error('cart-section');
      drawer.classList.remove('is-empty');drawer.renderContents(result);
     }catch{this.querySelector('.shc3-view-cart').focus();}
    }
    try{const cart=await fetch(root+'cart.js').then(r=>r.json());document.querySelectorAll('[data-shc3-cart-count]').forEach(el=>el.textContent=cart.item_count);}catch{}
    document.dispatchEvent(new CustomEvent('shc3:cart-added',{detail:result}));
   }catch(error){this.querySelector('.p-error').textContent=error.message||this.dataset.cartError;button.textContent=label;}
   finally{this.pending=false;button.disabled=false;}
  }
 });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shc3-search"]) return;
  try {
    
document.addEventListener('change', event => {
  if (event.target.matches('[data-shc3-search-sort]')) event.target.form.requestSubmit();
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const panel = event.target.closest('.shc3-search-filters[open]');
  if (panel) { panel.open = false; panel.querySelector('summary').focus(); }
});

  } catch(e) { console.error(e); }
})();
})();
